// Font stacks //
// Utility, Web-safe Fonts
const helvetica = "'Helvetica Neue', Helvetica, Arial, Roboto, sans-serif";
const georgia = "Georgia, 'Times New Roman', serif";

// Gap
// functional
export const gapBrandFont = helvetica;
export const gapFactoryBrandFont = helvetica;

// Banana Republic and Banana Republic Factory Store (BRFS)
const lynstone = "'Lynstone', Helvetica, Arial, sans-serif";
const bananaSerif = "'BananaSerif', 'Times New Roman', 'serif'";
//  functional
export const bananaRepublicFactoryBrandFont = lynstone;
export const bananaRepublicBrandFont = lynstone;
export const bananaRepublicBrandFontAlt = bananaSerif;
export const bananaRepublicFactoryBrandFontAlt = bananaSerif;

// Old Navy
//  functional
export const oldNavyFont = `'Gotham', ${helvetica}`;

// Deprecated - will be removed in a future version of React Stitch
export const oldNavyTertiaryFont = oldNavyFont;

// Athleta
export const athletaBrandFont = `'Avenir Next', ${helvetica}`;
export const athletaBrandFontAlt = "'Playfair', 'Times New Roman', 'serif'";

// Intermix
export const visuelt = `'Visuelt', ${helvetica}`;
export const miller = `'Miller Headline', ${georgia}`;

// Cross-Brand
const sourceSans = "'Source Sans Pro', Helvetica, Arial, Roboto, sans-serif";
//  functional
export const crossbrandFont = sourceSans;

export const fontSmoothing = {
  WebkitFontSmoothing: "antialiased",
  MozOsxFontSmoothing: "grayscale",
};
